/** Soft TTL cache for health-Details — shared by actions, hook, and reducer. */
const basicSaveByIdFetchedAt = new Map();

/** Same-case tab mounts reuse Redux within this window; after TTL, refetch for FO/app updates. */
export const BASIC_SAVE_DETAILS_SOFT_TTL_MS = 12000;

export const isBasicSaveDetailsFresh = (healthId) => {
  const key = healthId != null ? String(healthId) : "";
  if (!key) return false;
  const at = basicSaveByIdFetchedAt.get(key);
  if (at == null) return false;
  return Date.now() - at < BASIC_SAVE_DETAILS_SOFT_TTL_MS;
};

export const markBasicSaveDetailsFetched = (healthId) => {
  const key = healthId != null ? String(healthId) : "";
  if (key) basicSaveByIdFetchedAt.set(key, Date.now());
};
